export const templateDataObject = {
  ID: "",
  templateFooter: {
    text: "",
    count_of_variable: 0,
  },
  templateBody: {
    text: "",
    count_of_variable: 0,
    example: [],
  },
  templateHeader: {
    type: null,
    count_of_variable: 0,
    text: "",
    example: [],
  },
  templateButtons: {
    type: null,
    count_of_variable: 0,
    buttons: [],
  },
};

export function templateDataResponse(responseData) {
  return {
    ID: responseData._id || "",
    templateFooter: responseData.template_footer || {},
    templateBody: responseData.template_body || {},
    templateHeader: responseData.template_header || {},
    templateButtons: responseData.template_button || {},
  };
}
